import React, { createContext } from "react";
import { useOnePassShopHeroDealsQuery } from "../../generated/graphql";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var onePassHeroDealsInitialState = {
  entries: [],
  isSecondEntryCarousel: false
};
export var OnePassHeroDealsContext = /*#__PURE__*/createContext({
  data: onePassHeroDealsInitialState,
  loading: false
});
export var OnePassHeroDealsContextProvider = function OnePassHeroDealsContextProvider(_ref) {
  var _secondEntry$event;

  var children = _ref.children;

  var _useOnePassShopHeroDe = useOnePassShopHeroDealsQuery(),
      data = _useOnePassShopHeroDe.data,
      loading = _useOnePassShopHeroDe.loading;

  var _ref2 = (data === null || data === void 0 ? void 0 : data.onePassHeroEntries) || {},
      heroScheduleEntries = _ref2.heroScheduleEntries;

  var secondEntry = heroScheduleEntries && (heroScheduleEntries === null || heroScheduleEntries === void 0 ? void 0 : heroScheduleEntries.length) > 1 ? heroScheduleEntries[1] : null;
  var isSecondEntryCarousel = !!secondEntry && !!(secondEntry !== null && secondEntry !== void 0 && secondEntry.event) && (secondEntry === null || secondEntry === void 0 ? void 0 : (_secondEntry$event = secondEntry.event) === null || _secondEntry$event === void 0 ? void 0 : _secondEntry$event.sellableProductCount) >= 5;
  return ___EmotionJSX(OnePassHeroDealsContext.Provider, {
    value: {
      data: {
        entries: heroScheduleEntries || [],
        isSecondEntryCarousel: isSecondEntryCarousel
      },
      loading: loading
    }
  }, children);
};